import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BASE_URL_PATH, STONE_CREEK_MERCHANT_ID } from 'src/app/core/constants';
import { FulfillmentType } from 'src/app/core/models/order.model';
import { Order } from 'src/app/core/models/payment-item.model';
import { OrderApiService } from 'src/app/core/services/order.api.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { CartStore } from 'src/app/core/stores/cart.store';
import { PaymentStore, StatePayment } from 'src/app/core/stores/payment.store';
import { merchantConfig } from 'src/environments/merchant-config';
import * as moment from 'moment';
import { RestaurantStore } from 'src/app/core/stores/restaurant.store';
import { ItemValidateService } from 'src/app/core/services/item-validate.service';
import { NavController, Platform } from '@ionic/angular';
import { Platforms } from 'src/app/core/enums/util.enum';
import { Tip } from '../../../../core/enums/tip.enum';
import { Customer } from '../../../../core/models/customer.model';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss'],
})
export class OrderConfirmationComponent implements OnInit {
  public order: Order;
  public locationId: string;
  public currency = 'USD';
  public selectedFulfillmentTypeItem: string;
  public dateAndTime: string;
  public estimatedTimeInMinutes: number;
  public tip = Tip;
  public estimatedTimeForTableSide = 10;

  constructor(
    private orderApiService: OrderApiService,
    private route: ActivatedRoute,
    public cartStore: CartStore,
    private paymentStore: PaymentStore,
    private restaurantStore: RestaurantStore,
    private itemValidateService: ItemValidateService,
    private navController: NavController,
    private platform: Platform
  ) {}

  public get total(): number {
    return this.cartStore.totalCartPrice + this.deliveryCost;
  }

  public get deliveryCost(): number {
    return this.isDeliverySelected ? this.cartStore.deliveryFee / 100 : 0;
  }

  public get isDeliverySelected(): boolean {
    return this.selectedFulfillmentTypeItem && this.selectedFulfillmentTypeItem === FulfillmentType.DELIVERY;
  }

  public get orderConfirmationText(): string {
    return this.cartStore.orderConfirmationText;
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params.locationId) this.locationId = params.locationId;
      this.order = this.orderApiService.getOrderWithTipMoney(this.locationId);
      this.selectedFulfillmentTypeItem = this.order.fulfillment_type;
      this.dateAndTime = (this.selectedFulfillmentTypeItem === 'tableside') ?  moment().add(this.estimatedTimeForTableSide, 'minutes').format('dddd, MMM Do [at] h:mm a') :  moment(this.order.pickup_at).format('dddd, MMM Do [at] h:mm a');
      this.getETA();
    });
  }

  public getFormattedPrice(price: string | number, quantity = 1): string {
    return (+price * quantity).toFixed(2);
  }

  public navigateToHome(): void {
    this.resetOrderData();
    if (this.platform.is(Platforms.CORDOVA)) {
      this.navController.navigateRoot([BASE_URL_PATH, STONE_CREEK_MERCHANT_ID, 'home-screen']);
    } else {
      this.navController.navigateRoot([BASE_URL_PATH, STONE_CREEK_MERCHANT_ID]);
    }
  }

  private resetOrderData(): void {
    for (const locationId of Object.keys(this.cartStore.orderMap)) {
      this.cartStore.deleteItemsFromCartByLocationId(locationId);
    }
    this.cartStore.orderMap = {};
    this.cartStore.pickupAt = null;
    this.cartStore.isAsap = true;
    this.cartStore.loyalty = null;
    this.paymentStore.customer = new Customer();
    this.paymentStore.setStatePayment(StatePayment.INIT);
  }

  private getETA(): void {
    this.restaurantStore.restaurantAvailableStatus$.subscribe((status) => {
      if (status && this.cartStore.isAsap) {
        this.estimatedTimeInMinutes = this.itemValidateService.convertLeadTimeToMinutes(status.estimatedTimeToBeginPreparation);
        let prepTime = this.itemValidateService.convertLeadTimeToMinutes(this.order.estimated_prep_time_duration);
        if(this.estimatedTimeInMinutes > prepTime){
          prepTime = this.estimatedTimeInMinutes
        }
        this.dateAndTime = (this.selectedFulfillmentTypeItem === 'tableside') ? moment().add(this.estimatedTimeForTableSide, 'minutes').format('dddd, MMM Do [at] h:mm a') : moment(this.order.pickup_at).add(prepTime, 'minutes').format('dddd, MMM Do [at] h:mm a');
      }
    });
  }
}
